export { default as ProfileCard } from './profileCard';
export { profileCardType } from './profileCard.types';
export { profileCardStandard } from './__fixtures__/profileCard';
